module.exports = __webpack_public_path__ + "static/media/8OLA7.ae77253c.jpg";